import React, { useState } from 'react';
import { Button, Paper, Typography } from '@mui/material';
import { Fields } from '../Fields';
import AdminJHApi from "../../utils/AdminJHApi"
import { FIELD_TYPES } from '../../utils/utils';

export default function JobhuntRecruiters(props) {
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState();
    const [newData, setNewData] = useState({});
    const [results, setResults] = useState({noResults: true});

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else {
            return defaultValue
        }
    }

    const handleChangeField = e => {
        setNewData({...newData,[e.target.name]: e.target.value})
    };

    const handleSave = e => {
        e.preventDefault();

        setDisabled(true)
        setError()
        setResults({noResults: true})

        AdminJHApi.addJobPost(newData,(response)=>{
            setDisabled(false)
            setError()

            console.log(response)
            setResults(response||{})
        }, (error) => {
            console.log(error)
            if (error.message){
                setError(error.message)
            } else if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
            setDisabled(false)
        })
    }

    let fields = [
        { name: 'link', label: 'Link', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12}, 
        { name: 'post', label: 'Post', defaultValue: '', rows:3, rowsMax:8, type:FIELD_TYPES.MULTILINE, sm:12},  
        { name: 'textWithEmails', label: 'Text With Emails', defaultValue: '', rows:3, rowsMax:8, type:FIELD_TYPES.MULTILINE, sm:12},  
    ]

    return (
        <div className="pageMainContainer" >
            <Paper elevation={1} style={{margin:16, padding: 16}}>
                <form onSubmit={handleSave}>
                        <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
                        {(error)&&<Typography style={{marginTop:16}} color="error">{error}</Typography>}
                        <Button
                            disabled={disabled}
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="small"
                            aria-label='Save'
                            style={{marginTop:16}}
                        >
                            Save
                        </Button>
                </form>
            </Paper>
            {!results.noResults&&<>
                <div style={{display:'flex', marginTop: 16}}>
                    {((results.emailsSentErrors||[]).length>0)&&<Paper elevation={1} style={{margin:16, padding: 16}}>
                        <Typography color="error"><strong>{(results.emailsSentErrors||[]).length} Emails Failed</strong></Typography>
                        {(results.emailsSentErrors||[]).map(emailSentErrors => <Typography key={emailSentErrors}>{emailSentErrors}</Typography>)}
                    </Paper>}
                    <Paper elevation={1} style={{margin:16, padding: 16}}>
                        <Typography ><strong>{(results.emailsAddedToJobhuntDB||[]).length} Emails Added</strong></Typography>
                        {(results.emailsAddedToJobhuntDB||[]).map(emailAddedToJobhuntDB => <Typography key={emailAddedToJobhuntDB}>{emailAddedToJobhuntDB}</Typography>)}
                    </Paper>
                </div>
            </>}
        </div>
    )
}